import { Stack, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { Box } from "@mui/system";
import React from "react";
import { CalendarLoader, LiquidLoader, UserLoader } from "../lottie";

// import classes from './Spinner.module.css';

const Spinner = ({ height, width, module }) => {
  const loader = React.useCallback(() => {
    switch (module) {
      case "calendar":
        return (
          <Stack>
            <CalendarLoader
              height={height ?? 150}
              width={width ?? 150}
              loop={true}
            />
            <Typography
              variant="h6"
              sx={{ color: grey[500], textAlign: "center" }}
            >
              Loading Calendar...
            </Typography>
          </Stack>
        );
      case "groups":
        return (
          <Stack>
            <UserLoader
              height={height ?? 150}
              width={width ?? 150}
              loop={true}
            />
            <Typography
              variant="h6"
              sx={{ color: grey[500], textAlign: "center" }}
            >
              Loading Groups/Users...
            </Typography>
          </Stack>
        );
      default:
        return (
          <Stack>
            <LiquidLoader
              height={height ?? 180}
              width={width ?? 180}
              loop={true}
            />
            <Typography sx={{ opacity: 0.9, textAlign: "center" }}>
              Loading...
            </Typography>
          </Stack>
        );
    }
  }, [module, height, width]);

  return (
    <Box
      sx={{
        minHeight: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minWidth: "100%",
      }}
    >
      {loader(module ?? "default")}
    </Box>
  );
};

export default Spinner;
